import React, { Component } from 'react';
import { CirclePlus } from 'lucide-react';
import { APP_CONST } from '../../../../constants';
import { GeckoBtn, Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, toast } from '../../../../components';
import Composer from '../../../active-sessions/components/Composer';

export class ModuleApiTokens extends Component {
    state = {
        open: false,
        refreshTrigger: 0,
    }

    constructor(props) {
        super(props);
        this.openDialog = this.openDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.handleOpenChange = this.handleOpenChange.bind(this);
        this.didCreateToken = this.didCreateToken.bind(this);
    }

    openDialog() {
        this.setState({ open: true });
    }

    closeDialog() {
        this.setState({ open: false });
    }

    handleOpenChange(open) {
        this.setState({ open });
    }

    didCreateToken() {
        this.closeDialog();
        this.setState({ refreshTrigger: this.state.refreshTrigger + 1 });
        setTimeout(() => {
            toast.success('API token created successfully.');
        }, 300);
    }

    render() {
        return (
            <div className="flex flex-col gap-4 p-0"> 
                <div className="text-sm text-muted-foreground">
                    Click the button below to generate a new API token.
                </div>
                <div className="flex">
                    <GeckoBtn 
                        name="Create new API token" 
                        icon={CirclePlus}
                        type={APP_CONST.BTN_TYPE_PRIMARY}
                        className="self-start"
                        handler={this.openDialog}
                    />
                    <Dialog open={this.state.open} onOpenChange={this.handleOpenChange}>
                        <DialogContent className="sm:max-w-2xl">
                            <DialogHeader>
                                <DialogTitle>Create new API token</DialogTitle>
                                <DialogDescription>
                                    Create a new API token for programmatic access to your account.
                                </DialogDescription>
                            </DialogHeader>
                            <Composer onCreate={this.didCreateToken} />
                        </DialogContent>
                    </Dialog>
                </div>
            </div>
        );
    }
}

export default ModuleApiTokens;

